<template>
    <div class="tyn-root relatorios-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <main class="rel-page">
                    <div class="rel-container">
                        <section class="card page-head">
                            <div class="page-head__icon" aria-hidden="true">
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 18v-2M12 18v-5M16 18v-3"/></svg>
                            </div>
                            <div class="page-head__text">
                                <nav class="breadcrumb" aria-label="Trilha">
                                    <a href="#" @click.prevent="irInicio">Início</a>
                                    <span class="breadcrumb__sep">/</span>
                                    <span class="breadcrumb__current">Relatórios</span>
                                </nav>
                                <h1>Gerar relatório</h1>
                            </div>
                            <div class="page-head__contract" v-if="exibirSeletorContrato">
                                <label for="rel-contrato" class="eyebrow">Contrato</label>
                                <div class="select-wrap">
                                    <select id="rel-contrato" class="select" v-model="idContrato" :disabled="!lstContratos.length" @change="trocarContrato">
                                        <option v-if="!lstContratos.length" value="">
                                            {{ carregandoContratos ? 'Carregando contratos...' : 'Contrato atual' }}
                                        </option>
                                        <option v-for="item in lstContratos" :key="item.idContratoGnp" :value="item.idContratoGnp">
                                            {{ item.nrContrato }}/{{ item.nrAno }}
                                        </option>
                                    </select>
                                    <svg class="select-wrap__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
                                </div>
                            </div>
                        </section>

                        <div class="layout">
                            <div class="layout__main">
                                <section class="card section">
                                    <header class="section__head">
                                        <span class="section__icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                                        </span>
                                        <div class="section__title">
                                            <h2>Período</h2>
                                            <p>Escolha um atalho ou defina as datas. Sem data inicial, começa no início do contrato.</p>
                                        </div>
                                        <span class="pill">{{ rotuloDiasPeriodo }}</span>
                                    </header>
                                    <div class="chips" role="group" aria-label="Atalhos de período">
                                        <button v-for="item in atalhosPeriodo"
                                                :key="item.id"
                                                type="button"
                                                class="chip"
                                                :class="{ 'is-on': atalhoPeriodo === item.id }"
                                                :aria-pressed="atalhoPeriodo === item.id"
                                                @click="atalhoPeriodo = item.id">
                                            {{ item.label }}
                                        </button>
                                    </div>
                                    <div class="date-range">
                                        <label class="field">
                                            <span class="eyebrow">De</span>
                                            <span class="date-input" :class="{ 'is-custom': atalhoPeriodo === 'personalizado' }">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                                                <input type="date"
                                                       :value="intervalo.from"
                                                       :min="inicioContratoIso || undefined"
                                                       :max="intervalo.to || hojeIso"
                                                       @input="aoMudarData('from', $event)" />
                                            </span>
                                        </label>
                                        <span class="date-range__arrow" aria-hidden="true">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
                                        </span>
                                        <label class="field">
                                            <span class="eyebrow">Até</span>
                                            <span class="date-input" :class="{ 'is-custom': atalhoPeriodo === 'personalizado' }">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                                                <input type="date"
                                                       :value="intervalo.to"
                                                       :min="intervalo.from || inicioContratoIso || undefined"
                                                       :max="hojeIso"
                                                       @input="aoMudarData('to', $event)" />
                                            </span>
                                        </label>
                                    </div>
                                </section>

                                <section class="card section">
                                    <header class="section__head">
                                        <span class="section__icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                                        </span>
                                        <div class="section__title">
                                            <h2>Quem entra</h2>
                                            <p v-if="!isAdmin">O relatório considera só o seu uso.</p>
                                            <p v-else-if="carregandoPessoas">Carregando a equipe...</p>
                                            <p v-else>{{ pessoas.length }} {{ pessoas.length === 1 ? 'pessoa' : 'pessoas' }} na equipe deste contrato.</p>
                                        </div>
                                        <div v-if="isAdmin && !carregandoPessoas && !erroPessoas" class="segmented" role="group" aria-label="Quem entra">
                                            <button type="button" :class="{ 'is-on': escopoPessoas === 'equipe' }" @click="definirEscopoPessoas('equipe')">Toda a equipe</button>
                                            <button type="button" :class="{ 'is-on': escopoPessoas === 'especificas' }" @click="definirEscopoPessoas('especificas')">Escolher pessoas</button>
                                        </div>
                                    </header>

                                    <div v-if="!isAdmin" class="all-team">
                                        <span class="avatar">{{ iniciais(nomeUsuario) }}</span>
                                        <div class="all-team__text">
                                            <strong>{{ nomeUsuario || 'Você' }}</strong>
                                            <span>Administradores do contrato podem incluir a equipe.</span>
                                        </div>
                                    </div>
                                    <div v-else-if="carregandoPessoas" class="empty">Carregando a equipe...</div>
                                    <div v-else-if="erroPessoas" class="alert" role="alert">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                                        <span>{{ erroPessoas }}</span>
                                    </div>
                                    <div v-else-if="escopoPessoas === 'equipe'" class="all-team">
                                        <div class="avatar-stack">
                                            <span v-for="pessoa in pessoas.slice(0, 6)" :key="pessoa.dsLogin" class="avatar avatar--stack">{{ iniciais(pessoa.nmUsuario) }}</span>
                                            <span v-if="pessoas.length > 6" class="avatar avatar--stack avatar--more">+{{ pessoas.length - 6 }}</span>
                                        </div>
                                        <div class="all-team__text">
                                            <strong>Todas as {{ pessoas.length }} pessoas entram no relatório</strong>
                                            <span>Inclui o gestor do contrato quando ele faz parte da equipe.</span>
                                        </div>
                                        <button type="button" class="btn btn--ghost" @click="definirEscopoPessoas('especificas')">Escolher pessoas</button>
                                    </div>
                                    <div v-else class="pick">
                                        <div class="pick__toolbar">
                                            <label class="search">
                                                <span class="sr-only">Buscar pessoa</span>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
                                                <input v-model="buscaPessoa" type="search" placeholder="Buscar por nome ou e-mail" />
                                            </label>
                                            <span class="muted nowrap">{{ loginsSelecionados.length }} de {{ pessoas.length }}</span>
                                            <button type="button" class="btn btn--ghost" @click="marcarPessoasFiltradas">Marcar todos</button>
                                            <button type="button" class="btn btn--text" @click="limparPessoas">Limpar</button>
                                        </div>
                                        <div class="people-grid" v-if="pessoasFiltradas.length">
                                            <button v-for="pessoa in pessoasFiltradas"
                                                    :key="pessoa.dsLogin"
                                                    type="button"
                                                    class="person"
                                                    :class="{ 'is-on': pessoaMarcada(pessoa.dsLogin) }"
                                                    :aria-pressed="pessoaMarcada(pessoa.dsLogin)"
                                                    @click="alternarPessoa(pessoa.dsLogin)">
                                                <span class="checkbox" aria-hidden="true">
                                                    <svg v-if="pessoaMarcada(pessoa.dsLogin)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                </span>
                                                <span class="avatar">{{ iniciais(pessoa.nmUsuario) }}</span>
                                                <span class="person__text">
                                                    <span class="person__name">{{ pessoa.nmUsuario }}</span>
                                                    <span class="person__email">{{ pessoa.dsLogin }}</span>
                                                </span>
                                                <span v-if="pessoa.gestor" class="tag tag--role">Gestor</span>
                                            </button>
                                        </div>
                                        <p v-else class="empty">{{ pessoas.length ? 'Ninguém encontrado com esse nome ou e-mail.' : 'Nenhuma pessoa neste contrato.' }}</p>
                                    </div>
                                </section>

                                <section class="card section">
                                    <header class="section__head">
                                        <span class="section__icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
                                        </span>
                                        <div class="section__title">
                                            <h2>Produtos</h2>
                                            <p v-if="carregandoProdutos">Carregando produtos...</p>
                                            <p v-else>{{ produtos.length }} {{ produtos.length === 1 ? 'produto liberado' : 'produtos liberados' }} no contrato.</p>
                                        </div>
                                        <button v-if="produtos.length" type="button" class="btn btn--ghost" @click="alternarTodosProdutos">
                                            {{ todosProdutosMarcados ? 'Desmarcar todos' : 'Marcar todos' }}
                                        </button>
                                    </header>
                                    <div v-if="erroProdutos" class="alert" role="alert">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                                        <span>{{ erroProdutos }}</span>
                                    </div>
                                    <p v-else-if="!carregandoProdutos && !produtos.length" class="empty">Nenhum produto liberado para este usuário.</p>
                                    <div v-else class="products-grid">
                                        <button v-for="produto in produtos"
                                                :key="produto.idProduto"
                                                type="button"
                                                class="product"
                                                :class="{ 'is-on': produtoMarcado(produto.idProduto) }"
                                                :aria-pressed="produtoMarcado(produto.idProduto)"
                                                @click="alternarProduto(produto.idProduto)">
                                            <span class="product__icon" aria-hidden="true">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" v-html="iconeProduto(produto.cdIdentificador)"></svg>
                                            </span>
                                            <span class="product__text">
                                                <span class="product__name">{{ produto.nmProduto }}</span>
                                                <span class="product__status">{{ produtoMarcado(produto.idProduto) ? 'Incluído' : 'Fora do relatório' }}</span>
                                            </span>
                                            <span class="product__check" aria-hidden="true">
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                            </span>
                                        </button>
                                    </div>
                                </section>
                            </div>

                            <aside class="layout__aside">
                                <section class="card summary">
                                    <header class="summary__head">
                                        <h2>Resumo do relatório</h2>
                                        <span v-if="contratoSelecionado" class="pill">Contrato {{ contratoSelecionado.nrContrato }}/{{ contratoSelecionado.nrAno }}</span>
                                    </header>
                                    <div class="summary__list">
                                        <div class="summary__row">
                                            <span class="summary__icon" aria-hidden="true">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                                            </span>
                                            <div>
                                                <div class="eyebrow">Período</div>
                                                <div class="summary__value">{{ resumoPeriodo }}</div>
                                                <div class="muted small">{{ rotuloDiasPeriodo }}</div>
                                            </div>
                                        </div>
                                        <div class="summary__row">
                                            <span class="summary__icon" aria-hidden="true">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                                            </span>
                                            <div class="summary__body">
                                                <div>
                                                    <div class="eyebrow">Pessoas</div>
                                                    <div class="summary__value">{{ resumoQuem }}</div>
                                                </div>
                                                <div v-if="pessoasResumo.length" class="summary__chips">
                                                    <span v-for="pessoa in pessoasResumo" :key="pessoa.dsLogin" class="person-chip">
                                                        <span class="avatar avatar--xs">{{ iniciais(pessoa.nmUsuario) }}</span>
                                                        {{ primeiroNome(pessoa.nmUsuario) }}
                                                    </span>
                                                    <span v-if="pessoasResumoRestantes > 0" class="person-chip">+{{ pessoasResumoRestantes }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="summary__row">
                                            <span class="summary__icon" aria-hidden="true">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
                                            </span>
                                            <div class="summary__body">
                                                <div>
                                                    <div class="eyebrow">Produtos</div>
                                                    <div class="summary__value">{{ resumoProdutos }}</div>
                                                </div>
                                                <div v-if="produtosEscolhidos.length" class="summary__chips">
                                                    <span v-for="produto in produtosEscolhidos" :key="produto.idProduto" class="product-chip">{{ produto.nmProduto }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="format">
                                        <span class="eyebrow">Formato</span>
                                        <div class="format__options" role="group" aria-label="Formato">
                                            <button type="button" class="format__btn" :class="{ 'is-on': formato === 'pdf' }" @click="formato = 'pdf'">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h5"/></svg>
                                                PDF
                                            </button>
                                            <button type="button" class="format__btn" :class="{ 'is-on': formato === 'xlsx' }" @click="formato = 'xlsx'">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18"/></svg>
                                                Excel
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="mensagemInvalida" class="alert" role="alert">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                                        <span>{{ mensagemInvalida }}</span>
                                    </div>

                                    <div v-if="erroGeracao" class="alert" role="alert">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                                        <span>{{ erroGeracao }}</span>
                                    </div>

                                    <div class="actions">
                                        <button type="button" class="btn btn--primary" :disabled="!!mensagemInvalida || carregando || gerando" @click="pedirRelatorio(false)">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/></svg>
                                            {{ gerando && modoGeracao === 'arquivo' ? 'Gerando...' : 'Gerar relatório' }}
                                        </button>
                                        <button type="button" class="btn btn--outline" :disabled="!!mensagemInvalida || carregando || gerando" @click="pedirRelatorio(true)">
                                            {{ gerando && modoGeracao === 'previa' ? 'Montando...' : 'Pré-visualizar' }}
                                        </button>
                                    </div>
                                    <p v-if="selecaoConfirmada" class="hint hint--ok">
                                        Relatório baixado.
                                    </p>
                                </section>
                                <p class="hint">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
                                    As ações são as feitas no período e no contrato. Em Processos Inteligentes, o relatório lista os artefatos da pessoa. Em SollAI Academy, lista as trilhas que ela segue hoje e quais foram concluídas no período.
                                </p>
                            </aside>
                        </div>

                        <section v-if="previsualizacao" ref="previa" class="card previa">
                            <header class="previa__head">
                                <div>
                                    <h2>Pré-visualização</h2>
                                    <p>{{ rotuloPrevia }}</p>
                                </div>
                                <span class="pill">{{ previsualizacao.qtAcoes }} {{ previsualizacao.qtAcoes === 1 ? 'ação' : 'ações' }}</span>
                            </header>
                            <p v-if="!gruposPrevia.length" class="empty">Nenhuma ação neste período.</p>
                            <div v-for="pessoa in gruposPrevia" :key="pessoa.dsLogin" class="previa__pessoa">
                                <h3>{{ pessoa.nmUsuario }}</h3>
                                <div v-if="pessoa.prazos.length" class="previa__produto">
                                    <h4>Prazos dos artefatos</h4>
                                    <p class="previa__resumo">{{ pessoa.resumoPrazos }}</p>
                                    <div class="previa__tabela">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Processo</th>
                                                    <th>Artefato</th>
                                                    <th>Papel</th>
                                                    <th>Prazo</th>
                                                    <th>Situação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(prazo, indice) in pessoa.prazos" :key="'prazo-' + indice">
                                                    <td>{{ prazo.dsProcesso }}</td>
                                                    <td>{{ prazo.nmArtefato }}</td>
                                                    <td>{{ prazo.dsPapeis }}</td>
                                                    <td>{{ prazo.dtLimite ? formatarData(prazo.dtLimite) : '—' }}</td>
                                                    <td :class="prazo.classeSituacao">{{ prazo.nmSituacao }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="pessoa.academy" class="previa__produto">
                                    <h4>SollAI Academy</h4>
                                    <p v-if="pessoa.academy.flSemUso" class="empty">Não há registro de uso na SollAI Academy.</p>
                                    <template v-else>
                                        <p class="previa__resumo">{{ pessoa.academy.dsResumo }}</p>
                                        <div class="previa__tabela">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Trilha</th>
                                                        <th>Situação</th>
                                                        <th>Progresso</th>
                                                        <th>No período</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(trilha, indice) in pessoa.academy.trilhas" :key="'trilha-' + indice">
                                                        <td>{{ trilha.nmTrilha }}</td>
                                                        <td :class="trilha.classeSituacao">{{ trilha.nmSituacao }}</td>
                                                        <td>{{ trilha.dsProgresso }}</td>
                                                        <td>{{ trilha.dsNoPeriodo || '—' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                                <p v-if="!pessoa.produtos.length" class="empty">Nenhuma ação neste período.</p>
                                <div v-for="produto in pessoa.produtos" :key="pessoa.dsLogin + '-' + produto.cdProduto" class="previa__produto">
                                    <h4>{{ produto.nmProduto }}</h4>
                                    <div class="previa__tabela">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Data</th>
                                                    <th>Ação</th>
                                                    <th>Detalhe</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(linha, indice) in produto.linhas" :key="indice">
                                                    <td>{{ formatarDataHora(linha.dtAcao) }}</td>
                                                    <td>{{ linha.nmAcao }}</td>
                                                    <td>{{ linha.dsDetalhe || '—' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
        </div>

        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Relatorios',
        components: { Header, Modais },
        data() {
            return {
                escopoPessoas: 'equipe',
                escopoProdutos: 'todos',
                pessoas: [],
                produtos: [],
                loginsSelecionados: [],
                produtosSelecionados: [],
                buscaPessoa: '',
                lstContratos: [],
                idContrato: null,
                carregandoPessoas: false,
                carregandoProdutos: false,
                erroPessoas: '',
                erroProdutos: '',
                carregandoContratos: false,
                pedidoEquipe: 0,
                abortEquipe: null,
                dtInicioContrato: null,
                atalhoPeriodo: 'contrato',
                periodoPersonalizado: { from: '', to: '' },
                formato: 'pdf',
                selecaoConfirmada: false,
                gerando: false,
                modoGeracao: '',
                erroGeracao: '',
                previsualizacao: null,
                atalhosPeriodo: [
                    { id: 'contrato', label: 'Contrato inteiro' },
                    { id: 'mes', label: 'Este mês' },
                    { id: '30', label: 'Últimos 30 dias' },
                    { id: 'trimestre', label: 'Este trimestre' },
                    { id: 'personalizado', label: 'Personalizado' },
                ],
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },
            isContratoZero() {
                return this.user?.usuario?.idContrato === 0
            },
            isAdmin() {
                const admin = this.isAdmContrato == 'Sim'
                    || this.$store.state.isAdmin == 'Sim'
                    || this.user?.usuario?.isAdmin == 'Sim'
                    || this.user?.usuarioApi?.flAdministrador
                return admin || this.isContratoZero
            },
            exibirSeletorContrato() {
                return this.isAdmin && !this.isContratoZero
            },
            carregando() {
                return this.carregandoProdutos || (this.isAdmin && this.carregandoPessoas)
            },
            nomeUsuario() {
                return this.user?.usuarioApi?.nmUsuario || this.user?.usuario?.nmUsuario || ''
            },
            contratoSelecionado() {
                return (this.lstContratos || []).find(item => item.idContratoGnp == this.idContrato) || null
            },
            inicioContratoIso() {
                return this.paraIso(this.dtInicioContrato)
            },
            hojeIso() {
                return this.paraIsoData(new Date())
            },
            intervalo() {
                const hoje = this.hojeIso
                if (this.atalhoPeriodo === 'mes') {
                    const agora = new Date()
                    return { from: this.limitarInicio(this.paraIsoData(new Date(agora.getFullYear(), agora.getMonth(), 1))), to: hoje }
                }
                if (this.atalhoPeriodo === '30') {
                    const data = new Date()
                    data.setDate(data.getDate() - 29)
                    return { from: this.limitarInicio(this.paraIsoData(data)), to: hoje }
                }
                if (this.atalhoPeriodo === 'trimestre') {
                    const agora = new Date()
                    const inicio = Math.floor(agora.getMonth() / 3) * 3
                    return { from: this.limitarInicio(this.paraIsoData(new Date(agora.getFullYear(), inicio, 1))), to: hoje }
                }
                if (this.atalhoPeriodo === 'personalizado') return this.periodoPersonalizado
                return { from: this.inicioContratoIso, to: hoje }
            },
            intervaloValido() {
                const { from, to } = this.intervalo
                if (this.atalhoPeriodo === 'contrato' && !from) return !!to
                return !!from && !!to && from <= to
            },
            rotuloDiasPeriodo() {
                if (this.atalhoPeriodo === 'contrato' && !this.intervalo.from) return 'Desde o início do contrato'
                if (!this.intervaloValido || !this.intervalo.from || !this.intervalo.to) return 'Escolha as datas'
                const dias = this.diferencaDias(this.intervalo.from, this.intervalo.to)
                return `${dias} ${dias === 1 ? 'dia' : 'dias'}`
            },
            resumoPeriodo() {
                if (this.atalhoPeriodo === 'contrato' && !this.intervalo.from) return 'Início do contrato → hoje'
                if (!this.intervaloValido) return 'Datas a definir'
                const fim = this.intervalo.to === this.hojeIso ? 'hoje' : this.formatarData(this.intervalo.to)
                return `${this.formatarData(this.intervalo.from)} → ${fim}`
            },
            pessoasFiltradas() {
                const termo = this.normalizar(this.buscaPessoa)
                if (!termo) return this.pessoas
                return this.pessoas.filter(pessoa => {
                    return this.normalizar(pessoa.nmUsuario).includes(termo) || this.normalizar(pessoa.dsLogin).includes(termo)
                })
            },
            pessoasDoRelatorio() {
                if (!this.isAdmin || this.erroPessoas) {
                    return [{ dsLogin: this.user?.usuario?.dsEmail || 'voce', nmUsuario: this.nomeUsuario || 'Você' }]
                }
                if (this.escopoPessoas === 'equipe') return this.pessoas
                return this.pessoas.filter(pessoa => this.loginsSelecionados.includes(pessoa.dsLogin))
            },
            pessoasResumo() {
                return this.pessoasDoRelatorio.slice(0, 8)
            },
            pessoasResumoRestantes() {
                return Math.max(0, this.pessoasDoRelatorio.length - this.pessoasResumo.length)
            },
            resumoQuem() {
                if (!this.isAdmin || this.erroPessoas) return 'Só você'
                if (this.escopoPessoas === 'equipe') return `Toda a equipe (${this.pessoas.length})`
                const total = this.loginsSelecionados.length
                if (!total) return 'Ninguém selecionado'
                return total === 1 ? '1 pessoa' : `${total} pessoas`
            },
            produtosEscolhidos() {
                if (this.escopoProdutos === 'todos') return this.produtos
                return this.produtos.filter(produto => this.produtosSelecionados.includes(produto.idProduto))
            },
            todosProdutosMarcados() {
                return this.escopoProdutos === 'todos' && this.produtos.length > 0
            },
            resumoProdutos() {
                if (this.carregandoProdutos) return 'Carregando'
                const total = this.produtos.length
                const marcados = this.produtosEscolhidos.length
                if (!total || !marcados) return 'Nenhum selecionado'
                if (marcados === total) return `Todos (${marcados} de ${total})`
                return `${marcados} de ${total}`
            },
            mensagemInvalida() {
                if (this.carregando) return ''
                if (this.isAdmin && !this.erroPessoas && this.escopoPessoas === 'especificas' && this.loginsSelecionados.length === 0) {
                    return 'Escolha ao menos uma pessoa ou use Toda a equipe.'
                }
                if (!this.produtos.length || this.produtosEscolhidos.length === 0) return 'Selecione ao menos um produto.'
                if (!this.intervaloValido) return 'Defina as datas de início e fim do período.'
                return ''
            },
            gruposPrevia() {
                const classeDaSituacao = (situacao) => {
                    if (situacao === 'Atrasado' || situacao === 'Entregue em atraso') return 'sit sit--atraso'
                    if (situacao === 'Em dia' || situacao === 'Entregue no prazo') return 'sit sit--ok'
                    return 'sit'
                }
                const classeDaTrilha = (situacao) => {
                    if (situacao === 'Concluída') return 'sit sit--ok'
                    if (situacao === 'Em andamento') return 'sit sit--andamento'
                    return 'sit'
                }
                const textoResumoPrazos = (itens) => {
                    const situacoes = [
                        ['Atrasado', 'atrasado', 'atrasados'],
                        ['Entregue em atraso', 'entregue em atraso', 'entregues em atraso'],
                        ['Em dia', 'em dia', 'em dia'],
                        ['Entregue no prazo', 'entregue no prazo', 'entregues no prazo'],
                        ['Sem prazo', 'sem prazo', 'sem prazo'],
                    ]
                    const partes = []
                    situacoes.forEach(item => {
                        const situacao = item[0]
                        const um = item[1]
                        const varios = item[2]
                        const n = itens.filter(prazo => prazo.nmSituacao === situacao).length
                        if (n) partes.push(n + ' ' + (n === 1 ? um : varios))
                    })
                    return partes.join(' · ')
                }
                const linhas = this.previsualizacao?.linhas || []
                const prazos = this.previsualizacao?.prazos || []
                const academy = this.previsualizacao?.academy || []
                const pessoas = []
                const garantir = (dsLogin, nmUsuario) => {
                    let pessoa = pessoas.find(item => (item.dsLogin || '').toLowerCase() === (dsLogin || '').toLowerCase())
                    if (!pessoa) {
                        pessoa = { dsLogin, nmUsuario: nmUsuario || dsLogin, produtos: [], prazos: [], academy: null }
                        pessoas.push(pessoa)
                    }
                    if (nmUsuario && pessoa.nmUsuario === pessoa.dsLogin) pessoa.nmUsuario = nmUsuario
                    return pessoa
                }
                linhas.forEach(linha => {
                    const pessoa = garantir(linha.dsLogin, linha.nmUsuario)
                    let produto = pessoa.produtos.find(item => item.cdProduto === linha.cdProduto)
                    if (!produto) {
                        produto = { cdProduto: linha.cdProduto, nmProduto: linha.nmProduto || linha.cdProduto, linhas: [] }
                        pessoa.produtos.push(produto)
                    }
                    produto.linhas.push(linha)
                })
                prazos.forEach(prazo => {
                    garantir(prazo.dsLogin, prazo.nmUsuario).prazos.push({
                        ...prazo,
                        classeSituacao: classeDaSituacao(prazo.nmSituacao),
                    })
                })
                academy.forEach(bloco => {
                    const pessoa = garantir(bloco.dsLogin, bloco.nmUsuario)
                    pessoa.academy = {
                        flSemUso: !!bloco.flSemUso,
                        dsResumo: bloco.dsResumo || '',
                        trilhas: (bloco.trilhas || []).map(trilha => ({
                            ...trilha,
                            classeSituacao: classeDaTrilha(trilha.nmSituacao),
                        })),
                    }
                })
                pessoas.forEach(pessoa => { pessoa.resumoPrazos = textoResumoPrazos(pessoa.prazos) })
                pessoas.sort((a, b) => (a.nmUsuario || '').localeCompare(b.nmUsuario || '', 'pt-BR'))
                return pessoas
            },
            rotuloPrevia() {
                const resultado = this.previsualizacao
                if (!resultado) return ''
                const contrato = resultado.dsContrato ? `${resultado.dsContrato} · ` : ''
                const inicio = resultado.dtInicio ? this.formatarData(resultado.dtInicio) : 'início do contrato'
                const fim = resultado.dtFim ? this.formatarData(resultado.dtFim) : 'hoje'
                return `${contrato}${inicio} → ${fim}`
            },
        },
        watch: {
            escopoPessoas() { this.limparResultado() },
            escopoProdutos() { this.limparResultado() },
            loginsSelecionados() { this.limparResultado() },
            produtosSelecionados() { this.limparResultado() },
            atalhoPeriodo() { this.limparResultado() },
            periodoPersonalizado: {
                deep: true,
                handler() { this.limparResultado() },
            },
            formato() { this.selecaoConfirmada = false },
            idContrato() { this.limparResultado() },
        },
        methods: {
            irInicio() {
                this.$router.push({ name: 'Home' })
            },
            paraIso(valor) {
                if (!valor) return ''
                const match = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})/)
                return match ? `${match[1]}-${match[2]}-${match[3]}` : ''
            },
            paraIsoData(data) {
                const ano = data.getFullYear()
                const mes = String(data.getMonth() + 1).padStart(2, '0')
                const dia = String(data.getDate()).padStart(2, '0')
                return `${ano}-${mes}-${dia}`
            },
            deIso(valor) {
                const iso = this.paraIso(valor)
                if (!iso) return null
                const partes = iso.split('-').map(Number)
                return new Date(partes[0], partes[1] - 1, partes[2])
            },
            formatarData(valor) {
                const iso = this.paraIso(valor)
                if (!iso) return ''
                const partes = iso.split('-')
                return `${partes[2]}/${partes[1]}/${partes[0]}`
            },
            diferencaDias(inicio, fim) {
                const a = this.deIso(inicio)
                const b = this.deIso(fim)
                if (!a || !b) return 0
                return Math.round((b - a) / 86400000) + 1
            },
            limitarInicio(iso) {
                if (this.inicioContratoIso && iso < this.inicioContratoIso) return this.inicioContratoIso
                return iso
            },
            normalizar(texto) {
                return String(texto || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            },
            iniciais(nome) {
                const partes = String(nome || '').trim().split(/\s+/).filter(Boolean)
                if (!partes.length) return '?'
                const ultima = partes.length > 1 ? partes[partes.length - 1][0] : (partes[0][1] || '')
                return (partes[0][0] + ultima).toUpperCase()
            },
            primeiroNome(nome) {
                return String(nome || '').trim().split(/\s+/)[0] || nome
            },
            definirEscopoPessoas(escopo) {
                this.escopoPessoas = escopo
            },
            pessoaMarcada(login) {
                return this.loginsSelecionados.includes(login)
            },
            alternarPessoa(login) {
                if (this.pessoaMarcada(login)) {
                    this.loginsSelecionados = this.loginsSelecionados.filter(item => item !== login)
                    return
                }
                this.loginsSelecionados = this.loginsSelecionados.concat(login)
            },
            iconeProduto(codigo) {
                const icones = {
                    PI: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
                    SC: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
                    SA: '<path d="M22 10 12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>',
                    SO: '<path d="M9 18h6M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z"/>',
                    AP: '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/><path d="m8 11 2 2 4-4"/>',
                }
                return icones[codigo] || '<rect x="3" y="3" width="18" height="18" rx="3"/>'
            },
            produtoMarcado(idProduto) {
                if (this.escopoProdutos === 'todos') return true
                return this.produtosSelecionados.includes(idProduto)
            },
            idsProdutosMarcados() {
                if (this.escopoProdutos === 'todos') return this.produtos.map(produto => produto.idProduto)
                return this.produtosSelecionados.slice()
            },
            aplicarProdutos(ids) {
                if (this.produtos.length && ids.length === this.produtos.length) {
                    this.escopoProdutos = 'todos'
                    this.produtosSelecionados = []
                    return
                }
                this.escopoProdutos = 'especificos'
                this.produtosSelecionados = ids
            },
            alternarProduto(idProduto) {
                const ids = this.idsProdutosMarcados()
                const indice = ids.indexOf(idProduto)
                if (indice >= 0) ids.splice(indice, 1)
                else ids.push(idProduto)
                this.aplicarProdutos(ids)
            },
            alternarTodosProdutos() {
                if (this.todosProdutosMarcados) this.aplicarProdutos([])
                else this.aplicarProdutos(this.produtos.map(produto => produto.idProduto))
            },
            marcarPessoasFiltradas() {
                const selecionados = new Set(this.loginsSelecionados)
                this.pessoas.forEach(pessoa => selecionados.add(pessoa.dsLogin))
                this.loginsSelecionados = Array.from(selecionados)
            },
            limparPessoas() {
                this.loginsSelecionados = []
            },
            aoMudarData(qual, evento) {
                const base = this.atalhoPeriodo === 'personalizado'
                    ? { from: this.periodoPersonalizado.from, to: this.periodoPersonalizado.to }
                    : { from: this.intervalo.from, to: this.intervalo.to }
                base[qual] = evento.target.value
                this.periodoPersonalizado = base
                this.atalhoPeriodo = 'personalizado'
            },
            limparResultado() {
                this.selecaoConfirmada = false
                this.erroGeracao = ''
                this.previsualizacao = null
            },
            formatarDataHora(valor) {
                if (!valor) return ''
                const data = new Date(valor)
                if (Number.isNaN(data.getTime())) return ''
                return data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
            },
            montarPedido(formato) {
                const contrato = this.contratoSelecionado
                return {
                    idContrato: this.idContrato || this.user?.usuario?.idContrato || 0,
                    dtInicio: this.intervalo.from || '2000-01-01',
                    dtFim: this.intervalo.to,
                    formato,
                    dsContrato: contrato ? `Contrato ${contrato.nrContrato}/${contrato.nrAno}` : '',
                    pessoas: this.pessoasDoRelatorio.map(pessoa => ({ dsLogin: pessoa.dsLogin, nmUsuario: pessoa.nmUsuario })),
                    produtos: this.produtosEscolhidos.map(produto => ({ cdIdentificador: produto.cdIdentificador, nmProduto: produto.nmProduto })),
                }
            },
            async mensagemErroRelatorio(err) {
                const data = err && err.response ? err.response.data : null
                if (data instanceof Blob) {
                    try {
                        const json = JSON.parse(await data.text())
                        return json.msg || (json.errors && json.errors[0]) || 'Não foi possível gerar o relatório.'
                    } catch (e) {
                        return 'Não foi possível gerar o relatório.'
                    }
                }
                if (data && data.msg) return data.msg
                return 'Não foi possível gerar o relatório.'
            },
            async pedirRelatorio(previsualizar) {
                if (this.mensagemInvalida || this.carregando || this.gerando) return
                this.gerando = true
                this.modoGeracao = previsualizar ? 'previa' : 'arquivo'
                this.erroGeracao = ''
                this.selecaoConfirmada = false
                try {
                    if (previsualizar) {
                        const res = await axios.post(`${urlApi}/Relatorio/Acoes`, this.montarPedido('preview'), { showLoading: false })
                        if (!res.data || !res.data.success) {
                            this.erroGeracao = (res.data && res.data.msg) || 'Não foi possível montar a pré-visualização.'
                            return
                        }
                        this.previsualizacao = res.data.data
                        this.$nextTick(() => {
                            const painel = this.$refs.previa
                            if (painel && painel.scrollIntoView) painel.scrollIntoView({ behavior: 'smooth', block: 'start' })
                        })
                        return
                    }
                    const res = await axios.post(`${urlApi}/Relatorio/Acoes`, this.montarPedido(this.formato), {
                        responseType: 'blob',
                        showLoading: false,
                    })
                    const pdf = this.formato === 'pdf'
                    const blob = new Blob([res.data], {
                        type: pdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = pdf ? 'relatorio-acoes.pdf' : 'relatorio-acoes.xlsx'
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                    this.selecaoConfirmada = true
                } catch (err) {
                    this.erroGeracao = await this.mensagemErroRelatorio(err)
                } finally {
                    this.gerando = false
                    this.modoGeracao = ''
                }
            },
            trocarContrato() {
                this.loginsSelecionados = []
                this.buscaPessoa = ''
                this.limparResultado()
                this.atalhoPeriodo = 'contrato'
                this.aplicarVigenciaDoContratoSelecionado()
                this.carregarPessoas()
            },
            load() {
                this.carregarProdutos()
                if (!this.isAdmin || this.isContratoZero) this.carregarVigencia()
                if (!this.isAdmin) return
                if (this.isContratoZero) {
                    this.erroPessoas = 'Este usuário não tem uma equipe de contrato para selecionar.'
                    return
                }
                this.carregarContratos()
            },
            carregarVigencia() {
                const $this = this
                axios.get(`${urlApi}/ClienteContratoProduto/GetVigencia`, { showLoading: false })
                    .then(res => {
                        if (!res.data.success || !res.data.data) return
                        $this.dtInicioContrato = res.data.data.dtInicio || null
                    })
                    .catch(() => { })
            },
            aplicarVigenciaDoContratoSelecionado() {
                const contrato = this.contratoSelecionado
                this.dtInicioContrato = contrato?.dtInicio || null
            },
            carregarProdutos() {
                const $this = this
                $this.carregandoProdutos = true
                $this.erroProdutos = ''
                axios.get(`${urlApi}/Produto/GetPermissoesProdutos`, { showLoading: false })
                    .then(res => {
                        if (!res.data.success) {
                            $this.erroProdutos = 'Não foi possível carregar os produtos.'
                            return
                        }
                        const lista = res.data.data || []
                        const vistos = new Set()
                        $this.produtos = lista
                            .filter(item => item.flPossuiProduto && item.produto && !vistos.has(item.produto.idProduto) && vistos.add(item.produto.idProduto))
                            .map(item => ({
                                idProduto: item.produto.idProduto,
                                nmProduto: item.produto.nmProduto,
                                cdIdentificador: item.produto.cdIdentificador,
                            }))
                            .sort((a, b) => (a.nmProduto || '').localeCompare(b.nmProduto || '', 'pt-BR'))
                        $this.escopoProdutos = 'todos'
                        $this.produtosSelecionados = []
                    })
                    .catch(() => {
                        $this.erroProdutos = 'Não foi possível carregar os produtos.'
                    })
                    .finally(() => {
                        $this.carregandoProdutos = false
                    })
            },
            normalizarContratos(data) {
                const bruto = Array.isArray(data)
                    ? data
                    : (Array.isArray(data?.$values) ? data.$values : (Array.isArray(data?.lstContratos) ? data.lstContratos : []))
                return bruto
                    .filter(item => item && item.idContratoGnp != null)
                    .map(item => ({
                        idContratoGnp: item.idContratoGnp,
                        nrContrato: item.nrContrato,
                        nrAno: item.nrAno,
                        dtInicio: item.dtInicio,
                        dsLoginSupervisor: item.dsLoginSupervisor,
                    }))
            },
            carregarContratos() {
                const $this = this
                $this.carregandoContratos = true
                $this.carregandoPessoas = true
                axios.get(`${urlApi}/ClienteContratoProduto/GetContratos/`, { showLoading: false })
                    .then(res => {
                        const lista = $this.normalizarContratos(res.data?.data)
                        if (lista.length) {
                            $this.lstContratos = lista
                            const atual = $this.user?.usuario?.idContrato
                            const doUsuario = lista.find(item => item.idContratoGnp == atual)
                            if (!$this.idContrato || !lista.some(item => item.idContratoGnp == $this.idContrato)) {
                                $this.idContrato = doUsuario
                                    ? doUsuario.idContratoGnp
                                    : lista[0].idContratoGnp
                            }
                        } else if (!$this.idContrato) {
                            $this.idContrato = $this.user?.usuario?.idContrato
                        }
                        $this.aplicarVigenciaDoContratoSelecionado()
                        $this.carregarPessoas()
                    })
                    .catch(() => {
                        if (!$this.idContrato) $this.idContrato = $this.user?.usuario?.idContrato
                        $this.carregarPessoas()
                    })
                    .finally(() => {
                        $this.carregandoContratos = false
                    })
            },
            carregarPessoas() {
                const $this = this
                if ($this.abortEquipe) $this.abortEquipe.abort()
                const controle = new AbortController()
                $this.abortEquipe = controle
                const pedido = ++$this.pedidoEquipe
                const idContrato = $this.idContrato
                const aindaVale = () => pedido === $this.pedidoEquipe
                if (!idContrato) {
                    $this.carregandoPessoas = false
                    $this.pessoas = []
                    $this.erroPessoas = 'Não foi possível identificar o contrato da equipe.'
                    return
                }
                $this.carregandoPessoas = true
                $this.erroPessoas = ''
                $this.pessoas = []
                axios.get(`${urlApi}/ClienteContratoProduto/GetDadosGerenciamento/`, {
                    showLoading: false,
                    signal: controle.signal,
                    params: { idContrato },
                })
                    .then(res => {
                        if (!aindaVale()) return
                        if (!res.data.success) {
                            $this.erroPessoas = 'Não foi possível carregar as pessoas do contrato.'
                            return
                        }
                        const result = res.data.data || {}
                        if (!$this.dtInicioContrato && result.contrato?.dtInicio) $this.dtInicioContrato = result.contrato.dtInicio
                        $this.pessoas = $this.montarPessoas(result.lstUsuarioClienteLista, result.contrato, result.dados)
                    })
                    .catch(res => {
                        if (!aindaVale() || res?.code === 'ERR_CANCELED' || res?.name === 'CanceledError') return
                        if (res.response?.status === 403) {
                            $this.erroPessoas = 'Você não tem permissão para listar a equipe deste contrato.'
                        } else {
                            $this.erroPessoas = 'Não foi possível carregar as pessoas do contrato.'
                        }
                    })
                    .finally(() => {
                        if (aindaVale()) $this.carregandoPessoas = false
                    })
            },
            montarPessoas(lista, contrato, dados) {
                const pessoas = (lista || []).map(usuario => ({
                    dsLogin: usuario.dsLogin,
                    nmUsuario: usuario.nmUsuario || usuario.dsLogin,
                    gestor: false,
                }))
                const loginGestor = contrato?.dsLoginSupervisor
                const nomeGestor = dados?.dadosSupervisor?.usuario?.nmUsuario
                if (loginGestor) {
                    const gestor = pessoas.find(pessoa => pessoa.dsLogin === loginGestor)
                    if (gestor) gestor.gestor = true
                    else pessoas.push({ dsLogin: loginGestor, nmUsuario: nomeGestor || loginGestor, gestor: true })
                }
                return pessoas.sort((a, b) => (a.nmUsuario || '').localeCompare(b.nmUsuario || '', 'pt-BR'))
            },
        },
        mounted() {
            this.load()
        },
        beforeDestroy() {
            if (this.abortEquipe) this.abortEquipe.abort()
        },
    }
</script>

<style lang="scss" scoped>
    .relatorios-root ::v-deep .tyn-content {
        background: #dbe7fb;
    }

    .rel-page {
        --bg: #dbe7fb;
        --card: #ffffff;
        --ink: #0f1b35;
        --ink-2: #22324f;
        --muted: #5a6a85;
        --faint: #9aa8bf;
        --line: #e2e9f5;
        --line-2: #d5dfef;
        --soft: #f1f5fc;
        --field: #f7f9fd;
        --primary: #1f5fe0;
        --primary-ink: #1747b8;
        --primary-soft: #eef3fd;
        --primary-tint: #f1f6ff;
        --warn-bg: #fff6e5;
        --warn-line: #f3d08a;
        --warn-ink: #7a4300;
        --shadow: 0 1px 2px rgba(15, 27, 53, .04), 0 10px 30px rgba(31, 95, 224, .07);

        background: var(--bg);
        min-height: 100%;
        color: var(--ink);
        padding: 32px 24px 48px;
        box-sizing: border-box;
    }

    .rel-page *,
    .rel-page *::before,
    .rel-page *::after { box-sizing: border-box; }
    .rel-page button,
    .rel-page input,
    .rel-page select { font-family: inherit; }
    .rel-page button:focus-visible,
    .rel-page input:focus-visible,
    .rel-page select:focus-visible { outline: 3px solid rgba(31, 95, 224, .35); outline-offset: 2px; }

    .rel-container { max-width: 1200px; margin: 0 auto; display: flex; flex-direction: column; gap: 24px; }
    .card { background: var(--card); border-radius: 20px; box-shadow: var(--shadow); }

    .eyebrow { font-size: 11px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--muted); }
    .muted { color: var(--muted); font-size: 13px; }
    .small { font-size: 12.5px; }
    .nowrap { white-space: nowrap; }
    .sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
    .pill { font-size: 12.5px; font-weight: 600; color: var(--primary-ink); background: var(--primary-soft); padding: 6px 12px; border-radius: 999px; white-space: nowrap; }
    .tag { font-size: 11.5px; font-weight: 600; padding: 2px 9px; border-radius: 999px; flex-shrink: 0; }
    .tag--role { background: #ffeede; color: #8a3a00; }

    .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; border-radius: 12px; font-size: 13.5px; font-weight: 600; white-space: nowrap; }
    .btn:disabled { cursor: not-allowed; }
    .btn--ghost { height: 42px; padding: 0 14px; border: 1px solid var(--line-2); background: #fff; color: var(--primary); }
    .btn--ghost:hover { background: var(--primary-tint); border-color: #b9cdf4; }
    .btn--text { height: 42px; padding: 0 12px; border: 1px solid transparent; background: transparent; color: var(--muted); font-weight: 500; }
    .btn--text:hover { color: var(--ink); }
    .btn--primary { height: 52px; width: 100%; border-radius: 14px; border: none; background: var(--primary); color: #fff; font-size: 15px; box-shadow: 0 8px 20px rgba(31, 95, 224, .28); }
    .btn--primary:hover:not(:disabled) { background: var(--primary-ink); }
    .btn--primary:disabled { background: #c5d2ea; box-shadow: none; }
    .btn--outline { height: 46px; width: 100%; border-radius: 14px; background: #fff; color: var(--primary); border: 1px solid var(--line-2); font-size: 14px; }
    .btn--outline:hover:not(:disabled) { background: var(--primary-tint); }
    .btn--outline:disabled { color: var(--faint); border-color: var(--line); }

    .page-head { position: relative; z-index: 2; display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; gap: 24px; padding: 24px 28px; overflow: visible; }
    .page-head__icon { width: 56px; height: 56px; border-radius: 16px; background: var(--primary); color: #fff; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .page-head__text { flex: 1; min-width: 0; }
    .page-head__text h1 { margin: 0; font-size: 26px; font-weight: 700; letter-spacing: -.4px; color: var(--ink); }
    .page-head__text p { margin: 4px 0 0; font-size: 14px; color: var(--muted); }
    .breadcrumb { font-size: 12.5px; color: var(--muted); margin-bottom: 2px; }
    .breadcrumb a { color: var(--muted); text-decoration: none; }
    .breadcrumb a:hover { color: var(--primary); }
    .breadcrumb__sep { margin: 0 6px; color: var(--faint); }
    .breadcrumb__current { color: var(--ink-2); font-weight: 500; }
    .page-head__contract { display: flex; flex-direction: column; gap: 8px; width: 300px; flex: 0 0 300px; margin-left: auto; padding-left: 24px; border-left: 1px solid #e8edf6; }
    .page-head__contract .select:disabled { color: var(--muted); cursor: default; }
    .select-wrap { position: relative; }
    .select { appearance: none; width: 100%; height: 48px; border-radius: 12px; border: 1px solid var(--line-2); background: var(--field); padding: 0 44px 0 16px; font-size: 16px; font-weight: 600; color: var(--ink); cursor: pointer; }
    .select:hover { border-color: #b9cdf4; }
    .select-wrap__chevron { position: absolute; right: 16px; top: 15px; color: var(--ink-2); pointer-events: none; }

    .layout { display: grid; grid-template-columns: minmax(0, 1fr) 400px; gap: 24px; align-items: start; }
    .layout__main { display: flex; flex-direction: column; gap: 20px; min-width: 0; }
    .layout__aside { position: sticky; top: calc(var(--appbar-height, 73px) + 24px); z-index: 1; display: flex; flex-direction: column; gap: 16px; }

    .section { padding: 24px; display: flex; flex-direction: column; gap: 20px; }
    .section__head { display: flex; align-items: center; gap: 14px; }
    .section__icon { width: 34px; height: 34px; border-radius: 10px; background: var(--primary-soft); color: var(--primary); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .section__title { flex: 1; min-width: 0; }
    .section__title h2 { margin: 0; font-size: 17px; font-weight: 600; color: var(--ink); }
    .section__title p { margin: 2px 0 0; font-size: 13px; color: var(--muted); }

    .chips { display: flex; flex-wrap: wrap; gap: 8px; }
    .chip { height: 40px; padding: 0 16px; border-radius: 999px; font-size: 13.5px; font-weight: 500; background: #fff; color: var(--ink-2); border: 1px solid var(--line-2); cursor: pointer; }
    .chip:hover { border-color: #b9cdf4; background: var(--primary-tint); }
    .chip.is-on { background: var(--primary); color: #fff; border-color: var(--primary); }
    .date-range { display: flex; align-items: flex-end; gap: 12px; }
    .field { flex: 1; display: flex; flex-direction: column; gap: 6px; }
    .date-range__arrow { height: 48px; display: flex; align-items: center; color: var(--faint); }
    .date-input { display: flex; align-items: center; gap: 10px; height: 48px; padding: 0 14px; border-radius: 12px; background: var(--field); border: 1px solid var(--line-2); color: var(--muted); }
    .date-input.is-custom { background: #fff; border: 1.5px solid var(--primary); }
    .date-input input { flex: 1; border: none; background: transparent; font-size: 14.5px; font-weight: 500; color: var(--ink); outline: none; min-width: 0; }

    .segmented { display: flex; gap: 4px; background: var(--soft); padding: 4px; border-radius: 12px; flex-shrink: 0; }
    .segmented button { height: 36px; padding: 0 14px; border-radius: 9px; border: none; background: transparent; color: var(--muted); font-size: 13.5px; font-weight: 500; cursor: pointer; }
    .segmented button.is-on { background: #fff; color: var(--ink); font-weight: 600; box-shadow: 0 1px 3px rgba(15, 27, 53, .12); }

    .all-team { display: flex; align-items: center; gap: 16px; background: #f5f8fe; border: 1px dashed #c6d5f2; border-radius: 16px; padding: 18px 20px; }
    .all-team__text { flex: 1; display: flex; flex-direction: column; }
    .all-team__text strong { font-size: 14.5px; font-weight: 600; color: var(--ink); }
    .all-team__text span { font-size: 13px; color: var(--muted); }
    .avatar-stack { display: flex; padding-left: 8px; }
    .avatar { width: 38px; height: 38px; border-radius: 50%; background: #e2ebfc; color: var(--primary-ink); display: flex; align-items: center; justify-content: center; font-size: 12.5px; font-weight: 600; flex-shrink: 0; }
    .avatar--stack { width: 36px; height: 36px; margin-left: -8px; border: 2px solid #f5f8fe; font-size: 12px; }
    .avatar--more { background: var(--soft); color: var(--muted); }
    .avatar--xs { width: 22px; height: 22px; font-size: 9.5px; }

    .pick { display: flex; flex-direction: column; gap: 16px; }
    .pick__toolbar { display: flex; align-items: center; gap: 12px; }
    .search { flex: 1; position: relative; display: block; margin: 0; }
    .search svg { position: absolute; left: 14px; top: 13px; color: var(--muted); pointer-events: none; }
    .search input { width: 100%; height: 44px; border-radius: 12px; border: 1px solid var(--line-2); background: var(--field); padding: 0 14px 0 42px; font-size: 14px; color: var(--ink); }
    .search input:focus { background: #fff; border-color: var(--primary); }
    .people-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .person { display: flex; align-items: center; gap: 12px; width: 100%; text-align: left; padding: 12px 14px; border-radius: 14px; background: #fff; border: 1px solid var(--line); cursor: pointer; }
    .person:hover { border-color: #b9cdf4; }
    .person.is-on { background: var(--primary-tint); border-color: #9dbaf3; box-shadow: 0 0 0 3px rgba(31, 95, 224, .08); }
    .checkbox { width: 20px; height: 20px; border-radius: 6px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #fff; border: 1.5px solid #b8c6de; }
    .person.is-on .checkbox { background: var(--primary); border-color: var(--primary); }
    .person__text { flex: 1; min-width: 0; display: flex; flex-direction: column; }
    .person__name { font-size: 14px; font-weight: 600; color: var(--ink); }
    .person__email { font-size: 12.5px; color: var(--muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .empty { text-align: center; padding: 16px; margin: 0; font-size: 13.5px; color: var(--muted); }

    .products-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
    .product { display: flex; align-items: center; gap: 12px; width: 100%; min-height: 76px; text-align: left; padding: 14px; border-radius: 16px; background: #fff; border: 1.5px solid var(--line); cursor: pointer; }
    .product:hover { border-color: #b9cdf4; }
    .product.is-on { background: var(--primary-tint); border-color: var(--primary); }
    .product__icon { width: 40px; height: 40px; border-radius: 12px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: var(--soft); color: var(--muted); }
    .product.is-on .product__icon { background: var(--primary); color: #fff; }
    .product__text { flex: 1; min-width: 0; display: flex; flex-direction: column; }
    .product__name { font-size: 14px; font-weight: 600; color: var(--ink); }
    .product__status { font-size: 12px; color: var(--muted); }
    .product.is-on .product__status { color: var(--primary-ink); font-weight: 500; }
    .product__check { width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #fff; border: 1.5px solid #c3cfe3; }
    .product__check svg { opacity: 0; }
    .product.is-on .product__check { background: var(--primary); border-color: var(--primary); }
    .product.is-on .product__check svg { opacity: 1; }

    .summary { padding: 24px; display: flex; flex-direction: column; gap: 20px; }
    .summary__head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
    .summary__head h2 { margin: 0; font-size: 17px; font-weight: 600; color: var(--ink); }
    .summary__list { border: 1px solid #e8edf6; border-radius: 16px; }
    .summary__row { display: flex; gap: 12px; padding: 16px; }
    .summary__row + .summary__row { border-top: 1px solid #e8edf6; }
    .summary__icon { width: 32px; height: 32px; border-radius: 10px; background: var(--soft); color: var(--ink-2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .summary__body { flex: 1; display: flex; flex-direction: column; gap: 8px; min-width: 0; }
    .summary__value { font-size: 14.5px; font-weight: 600; color: var(--ink); }
    .summary__chips { display: flex; flex-wrap: wrap; gap: 6px; }
    .person-chip { display: inline-flex; align-items: center; gap: 6px; background: var(--soft); border-radius: 999px; padding: 3px 10px 3px 3px; font-size: 12px; font-weight: 500; color: var(--ink-2); }
    .product-chip { background: var(--primary-soft); color: var(--primary-ink); border-radius: 999px; padding: 4px 10px; font-size: 12px; font-weight: 500; }

    .format { display: flex; flex-direction: column; gap: 8px; }
    .format__options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
    .format__btn { display: flex; align-items: center; justify-content: center; gap: 8px; height: 48px; border-radius: 12px; font-size: 14px; font-weight: 600; background: #fff; color: #3d4d6a; border: 1.5px solid var(--line-2); cursor: pointer; }
    .format__btn.is-on { background: var(--primary-tint); color: var(--primary-ink); border-color: var(--primary); }

    .alert { display: flex; gap: 10px; align-items: flex-start; background: var(--warn-bg); border: 1px solid var(--warn-line); color: var(--warn-ink); border-radius: 12px; padding: 12px 14px; font-size: 13px; }
    .alert svg { flex-shrink: 0; margin-top: 2px; }
    .actions { display: flex; flex-direction: column; gap: 10px; }
    .hint { display: flex; gap: 10px; align-items: flex-start; margin: 0; padding: 0 8px; font-size: 12.5px; color: #3d4d6a; line-height: 1.5; }
    .hint svg { flex-shrink: 0; margin-top: 2px; }
    .hint--ok { color: #15803d; padding: 0; }

    .previa { margin-top: 18px; padding: 24px; }
    .previa__head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 16px; }
    .previa__head h2 { margin: 0; font-size: 17px; font-weight: 600; color: var(--ink); }
    .previa__head p { margin: 4px 0 0; font-size: 13px; color: var(--muted); }
    .previa__pessoa + .previa__pessoa { margin-top: 22px; }
    .previa__pessoa h3 { margin: 0 0 10px; font-size: 15px; font-weight: 600; color: var(--ink); }
    .previa__produto + .previa__produto { margin-top: 14px; }
    .previa__produto h4 { margin: 0 0 8px; font-size: 13px; font-weight: 600; color: var(--ink-2); }
    .previa__resumo { margin: -4px 0 8px; font-size: 12.5px; color: var(--muted); }
    .sit--atraso { color: #b91c1c; font-weight: 600; }
    .sit--ok { color: #15803d; font-weight: 600; }
    .sit--andamento { color: #1d4ed8; font-weight: 600; }
    .previa__tabela { overflow-x: auto; border: 1px solid var(--line); border-radius: 12px; }
    .previa table { width: 100%; border-collapse: collapse; font-size: 13px; }
    .previa th, .previa td { padding: 10px 12px; text-align: left; vertical-align: top; border-bottom: 1px solid var(--line); }
    .previa th { font-size: 12px; font-weight: 600; color: var(--muted); background: var(--soft); }
    .previa tr:last-child td { border-bottom: 0; }
    .previa td:first-child { white-space: nowrap; }

    @media (max-width: 1100px) {
        .layout { grid-template-columns: 1fr; }
        .layout__aside { position: static; }
        .products-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    }

    @media (max-width: 760px) {
        .rel-page { padding: 20px 16px 32px; }
        .page-head { flex-wrap: wrap; padding: 20px; }
        .page-head__contract { width: 100%; flex-basis: 100%; margin-left: 0; padding-left: 0; border-left: none; padding-top: 16px; border-top: 1px solid #e8edf6; }
        .section__head { flex-wrap: wrap; }
        .segmented { width: 100%; }
        .segmented button { flex: 1; }
        .pick__toolbar { flex-wrap: wrap; }
        .search { flex-basis: 100%; }
        .people-grid,
        .products-grid { grid-template-columns: 1fr; }
        .date-range { flex-direction: column; align-items: stretch; }
        .date-range__arrow { display: none; }
        .all-team { flex-wrap: wrap; }
    }

    [data-bs-theme="dark"] .relatorios-root ::v-deep .tyn-content,
    [data-bs-theme="dark"] .rel-page {
        --bg: #0b1220;
        --card: #162033;
        --ink: #f8fafc;
        --ink-2: #dbe4f3;
        --muted: #9aa8bf;
        --faint: #7d8da8;
        --line: rgba(148, 163, 184, .22);
        --line-2: rgba(148, 163, 184, .32);
        --soft: #1e293b;
        --field: #111a2c;
        --primary-soft: rgba(31, 95, 224, .22);
        --primary-tint: rgba(31, 95, 224, .16);
        --shadow: 0 10px 30px rgba(0, 0, 0, .28);
        background: var(--bg);
    }

    [data-bs-theme="dark"] .chip,
    [data-bs-theme="dark"] .person,
    [data-bs-theme="dark"] .product,
    [data-bs-theme="dark"] .btn--ghost,
    [data-bs-theme="dark"] .btn--outline,
    [data-bs-theme="dark"] .format__btn,
    [data-bs-theme="dark"] .date-input.is-custom,
    [data-bs-theme="dark"] .search input:focus {
        background: #111a2c;
    }

    [data-bs-theme="dark"] .segmented button.is-on,
    [data-bs-theme="dark"] .checkbox,
    [data-bs-theme="dark"] .product__check {
        background: #0f172a;
    }

    [data-bs-theme="dark"] .all-team {
        background: rgba(31, 95, 224, .08);
        border-color: rgba(147, 197, 253, .35);
    }

    [data-bs-theme="dark"] .hint { color: #cbd5e1; }
</style>
